import React, { useEffect, useMemo, useState } from 'react';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { Input, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { BsCalendar2Date } from 'react-icons/bs';

import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { convertToYYYYMMDD } from 'modules/Common';
import Pagination from '@material-ui/lab/Pagination';
import CallbackStartLogTable from './components/CallbackStartLogTable';
import { retrieveCallbackStart } from 'data/CallbackLog/datasources/CallbackLog.datasource';
import { getCallbackStart } from 'data/CallbackLog/repositories/CallbackLog.repository';
import { ResponseList } from 'models/Response';
import { LogCallbackStartResponse } from 'data/CallbackLog/schemas/CallbackLog.schema';
import {
    MasterCompanyList,
    MasterCompanyResponse
} from 'models/company/MasterCompany';
import axios from 'axios';
import { FiRefreshCw } from 'react-icons/fi';
import useLoader from 'hooks/useLoader';
import { useAdminCompanies } from '../../../hooks';

function CallbackLogStart() {
    const loader = useLoader();

    const { adminCompanies, isAllowedAllCompanies } = useAdminCompanies();
    const adminCompanySIDSet = useMemo(
        () =>
            adminCompanies
                ? new Set(adminCompanies.map(company => company.sid))
                : undefined,
        [adminCompanies]
    );

    const [timer, setTimer] = useState(120);
    const [isToggled, setIsToggled] = useState(true);

    const [callbackLogResponse, setCallbackLogResponse] =
        useState<ResponseList<LogCallbackStartResponse>>();

    const filteredCallbackLogs = useMemo(
        () =>
            isAllowedAllCompanies
                ? callbackLogResponse?.result_list ?? []
                : callbackLogResponse?.result_list.filter(log => {
                      return adminCompanySIDSet?.has(log.sid);
                  }) ?? [],
        [isAllowedAllCompanies, adminCompanySIDSet, callbackLogResponse]
    );

    useEffect(() => {
        fetchCallbackLogStart();

        let interval;

        if (isToggled) {
            interval = setInterval(() => {
                setTimer(prevTimer => {
                    if (prevTimer === 1) {
                        fetchCallbackLogStart();

                        return 30;
                    } else {
                        return prevTimer - 1;
                    }
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isToggled]);

    const handleChange = () => {
        setIsToggled(!isToggled);
    };

    const fetchCallbackLogStart = async () => {
        try {
            loader.show();
            const [, response] = await getCallbackStart();

            if (response) {
                setCallbackLogResponse(response);
            }
        } finally {
            loader.hide();
        }
    };
    const handleRefreshData = () => {
        fetchCallbackLogStart();
    };

    return (
        <Container>
            <Row>
                <Col className="import-export-actions">
                    <div
                        className="trapezoid-head"
                        style={{ width: '200px' }}
                    >
                        <span>Callback Stat</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="mat-box mb-5 rounded bg-white p-3 shadow">
                        <Row>
                            <Col>
                                <div className="mt-2">
                                    <Row>
                                        <Col
                                            xs={12}
                                            md={4}
                                        >
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicEmail"
                                            >
                                                <Label>Auto Refresh</Label>
                                                <button
                                                    onClick={handleChange}
                                                    className={`ml-3 ${
                                                        isToggled
                                                            ? 'bg-green-500'
                                                            : 'bg-red-500'
                                                    } rounded-lg px-4 py-2 text-white transition-colors duration-300 ease-in-out`}
                                                >
                                                    {isToggled ? 'ON' : 'OFF'}
                                                </button>
                                                <span className="ml-5 border-l-2 border-gray-950" />
                                                <button
                                                    onClick={handleRefreshData}
                                                    className="ml-5 rounded-md bg-blue-600 px-4 py-2 text-white"
                                                >
                                                    Refresh <FiRefreshCw />
                                                </button>
                                                <Label className="ml-5">
                                                    Total Server :{' '}
                                                    {
                                                        filteredCallbackLogs?.length
                                                    }{' '}
                                                    ON:{' '}
                                                    <span className="text-green-700">
                                                        {
                                                            filteredCallbackLogs?.length
                                                        }
                                                    </span>{' '}
                                                    OFF:{' '}
                                                    <span className="text-red-700">
                                                        0
                                                    </span>
                                                </Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <CallbackStartLogTable
                        logCallbackResult={filteredCallbackLogs}
                    />
                </Col>
            </Row>
        </Container>
    );
}

export default CallbackLogStart;
